module.exports = __webpack_public_path__ + "static/media/Spring.82a4bda4.png";